import styled from "styled-components"
export const BorderedCrouselWrapper = styled.div`
  margin-top: 40px;
  cursor:pointer;
  h1 {
    margin-bottom: 4px;
    font-size: 28px;
    font-weight: 700;
    line-height: 30.8px;
  }

  text {
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
  }
`;
